var exports = {
  "dL": "GuildHeader.module__headerWrapper___dnNvVT",
  "N1": "GuildHeader.module__headerContainer___dnNvVT",
  "bp": "GuildHeader.module__headerContainerActive___dnNvVT",
  "vf": "GuildHeader.module__headerContainerBanner___dnNvVT",
  "Le": "GuildHeader.module__headerContainerCollapsing___dnNvVT",
  "On": "GuildHeader.module__headerContainerNoBanner___dnNvVT",
  "nL": "GuildHeader.module__bannerClip___dnNvVT",
  "_e": "GuildHeader.module__bannerImage___dnNvVT",
  "Oo": "GuildHeader.module__bannerImageCentered___dnNvVT",
  "iI": "GuildHeader.module__headerGlass___dnNvVT",
  "nY": "GuildHeader.module__bannerGradient___dnNvVT",
  "VW": "GuildHeader.module__headerContent___dnNvVT",
  "KZ": "GuildHeader.module__headerFocusRing___dnNvVT",
  "w$": "GuildHeader.module__verifiedIcon___dnNvVT",
  "Ve": "GuildHeader.module__verifiedIconDefault___dnNvVT" + " " + "GuildHeader.module__verifiedIcon___dnNvVT",
  "J5": "GuildHeader.module__guildName___dnNvVT",
  "K8": "GuildHeader.module__guildNameDefault___dnNvVT" + " " + "GuildHeader.module__guildName___dnNvVT",
  "rr": "GuildHeader.module__guildNameWithBanner___dnNvVT" + " " + "GuildHeader.module__guildName___dnNvVT",
  "Rq": "GuildHeader.module__caretIcon___dnNvVT",
  "Ic": "GuildHeader.module__caretIconDefault___dnNvVT" + " " + "GuildHeader.module__caretIcon___dnNvVT",
  "Tu": "GuildHeader.module__caretIconWithBanner___dnNvVT" + " " + "GuildHeader.module__caretIcon___dnNvVT",
  "xu": "GuildHeader.module__caretIconOpen___dnNvVT",
  "_S": "GuildHeader.module__dotsIcon___dnNvVT",
  "D1": "GuildHeader.module__dotsIconDefault___dnNvVT" + " " + "GuildHeader.module__dotsIcon___dnNvVT",
  "GX": "GuildHeader.module__dotsIconWithBanner___dnNvVT" + " " + "GuildHeader.module__dotsIcon___dnNvVT",
};

module.exports = exports;
